import { Box, Button } from "@mui/material";
import "./SellerProfileHeaderContainer.scss";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const SellerProfileHeaderContainer = ({ ...props }) => {
  const { company_name } = useSelector((state: any) => state.sellerProfile);
  const navigate = useNavigate();
  const { t , i18n } = useTranslation();

  const getBackToProfileText = (language, companyName) => {
    switch (language) {
      case 'fr':
        return `${t('sellerProfile.dashboard.backTo')} ${t('sellerProfile.dashboard.profile').toLowerCase()} ${company_name}`;
      case 'en':
        return `${t('sellerProfile.dashboard.backTo')} ${company_name} ${t('sellerProfile.dashboard.profile')}`;
      default:
        return `${t('sellerProfile.dashboard.backTo')} ${company_name} ${t('sellerProfile.dashboard.profile')}`;
    }
  };
  return (
    <main className="mainContainer">
      <>
        <Button
          onClick={() => navigate(`/${i18n.language}/seller-profile`)}
          className="profileBackButton"
        >
          <KeyboardArrowLeftIcon className="profileBackIcon" />
          {getBackToProfileText(i18n.language, company_name)}
        </Button>
        {props.render()} </>
    </main>
  );
};

export default SellerProfileHeaderContainer;
